module.exports = __webpack_public_path__ + "img/iconfinder_facebook-social-media_765252-dark.a2e7e839.svg";